import * as React from 'react'

function SvgCateMovie(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M20.475 2l.836 3.729-17.23 3.864h17.66v10.848c0 .58-.472 1.052-1.053 1.052H3.858c-.58 0-1.052-.472-1.052-1.052L2.804 9.729 2 6.144 20.475 2zm.438 11.414H3.633v7.027c0 .122.103.225.225.225h16.83a.228.228 0 00.225-.225v-7.027zm-2.093 4.45v.743H5.727v-.744H18.82zm0-2.597v.744H5.727v-.744H18.82zm2.093-4.847h-1.401l-2.228 2.167h3.63V10.42zm-13.76 0h-3.52v2.167h1.292l2.228-2.167zm5.642 0H8.339L6.11 12.587h4.455l2.229-2.167zm5.531 0H13.98l-2.228 2.167h4.33l.238-.013-.099-.106 2.105-2.048zM6.422 6l-3.434.77.473 2.115 1.26-.283 1.7-2.603zm5.505-1.235l-4.348.975-1.7 2.602 4.348-.974 1.7-2.603zm5.398-1.211l-4.24.95-1.7 2.604 4.224-.948.237-.067-.126-.082 1.605-2.457zm2.525-.566l-1.368.306-1.7 2.603 3.541-.794-.473-2.115z" />
    </svg>
  )
}

export default SvgCateMovie
